import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let block = document.querySelector('.service-portfolio');

if(block) {

    gsap.from('.service-item', {
        scrollTrigger: {
            trigger: '.service-list',
            start: 'top 90%'
        },
        y: 20,
        autoAlpha: 0,
        stagger: 0.15
    });
}